import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";
import { memo } from "react";

// Lightweight world topology (public CDN)
const GEO_URL =
  "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

// Approx region centroids
const REGION_POINTS = {
  EU: { coord: [10, 50], label: "EU" },
  USA: { coord: [-98, 39], label: "USA" },
  UK: { coord: [-2, 54], label: "UK" },
  India: { coord: [78, 22], label: "India" },
  GCC: { coord: [50, 25], label: "GCC" },
  China: { coord: [104, 35], label: "China" },
  "South Korea": { coord: [127, 37], label: "Korea" },
};

function WorldMapBase({ regionData = [] }) {
  // regionData: [{region, count, high}]
  const maxCount = Math.max(1, ...regionData.map((r) => r.count || 0));
  const byRegion = Object.fromEntries(regionData.map((r) => [r.region, r]));

  return (
    <div className="w-full" data-testid="world-map">
      <ComposableMap
        projectionConfig={{ scale: 150 }}
        width={900}
        height={420}
        style={{ width: "100%", height: "auto", background: "#FFFFFF" }}
      >
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                style={{
                  default: {
                    fill: "#EFECE6",
                    stroke: "#D6D1C4",
                    strokeWidth: 0.5,
                    outline: "none",
                  },
                  hover: {
                    fill: "#E5E2DC",
                    stroke: "#A66E4E",
                    strokeWidth: 0.6,
                    outline: "none",
                  },
                  pressed: { fill: "#E5E2DC", outline: "none" },
                }}
              />
            ))
          }
        </Geographies>

        {Object.entries(REGION_POINTS).map(([region, p]) => {
          const data = byRegion[region] || { count: 0, high: 0 };
          const intensity = data.count / maxCount;
          const size = 5 + intensity * 14;
          const isDanger = data.high > 0;
          const color = isDanger ? "#D93636" : "#40593B";
          return (
            <Marker key={region} coordinates={p.coord}>
              {isDanger && (
                <circle
                  r={size}
                  fill={color}
                  fillOpacity={0.35}
                  className="vigil-ping"
                />
              )}
              <circle r={Math.max(3, size * 0.6)} fill={color} opacity={0.9} />
              <text
                y={-size - 6}
                textAnchor="middle"
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontSize: 10,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  fontWeight: 600,
                  fill: "#1C1B1A",
                }}
              >
                {p.label} · {data.count}
              </text>
            </Marker>
          );
        })}
      </ComposableMap>
    </div>
  );
}

export default memo(WorldMapBase);
